// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__LVy+h","Background":"Preloader_Background__Z0Ccy","smoke":"Preloader_smoke__Qa9wz","text":"Preloader_text__geSRO","waviy":"Preloader_waviy__-RpYx"};